import { useDeviceSelector } from 'js/store/hooks';
import { prop } from 'ramda';
import { useEffect } from 'react';

export const useWrapperCSSClasses = (config, setWrapperClassNames) => {
    const formFactor = useDeviceSelector(prop('formFactor'));
    const { portletViewMode, enableSorting, viewAllPageLink, enableViewOptions, enableFilters } = config;

    useEffect(() => {
        const classNames = ['bingoScheduler'];
        const showViewMore =
            portletViewMode === 'SHORT' &&
            viewAllPageLink;
        const showViewModes =
            enableViewOptions &&
            portletViewMode !== 'SHORT' &&
            formFactor !== 'mobile';

        if (showViewMore) {
            classNames.push('bingoScheduler--view-more');
        }

        if (showViewModes) {
            classNames.push('bingoScheduler--view-modes');
        }

        if (enableSorting) {
            classNames.push('bingoScheduler--sorting');
        }

        if (enableFilters) {
            classNames.push('bingoScheduler--filters');
        }

        setWrapperClassNames(classNames);

        return () => {
            setWrapperClassNames([]);
        };
    }, [
        portletViewMode,
        enableSorting,
        viewAllPageLink,
        enableViewOptions,
        enableFilters,
        setWrapperClassNames,
        formFactor
    ]);
};
